<app-base-modal
  [title]="'Файлы Отзыва'"
>
  <div class="content">
    @for (accordion of accordionFeedbackMedia; track $index) {
      <mat-accordion>
        <mat-expansion-panel [disabled]="isDisabledAccordion(accordion.type)">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ getTitle(accordion) }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="accordion-content">
            @switch (accordion.type) {
              @case ('image') {
                <div class="files">
                  @for (photoLink of feedbackMediaDialogData.media.photoLinks; track $index) {
                    <app-feedback-media-image
                      [feedbackMediaProps]="{
                        url: photoLink,
                        index: $index
                      }"
                    />
                  }
                </div>
              }
              @case ('video') {
                @for (videoLink of feedbackMediaDialogData.media.videoLinks; track $index) {
                  <app-feedback-media-video
                    [feedbackMediaProps]="{
                      url: videoLink,
                      index: $index
                    }"
                  />
                }
              }
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    }
  </div>
</app-base-modal>
